export default "__VITE_ASSET__46d4f711__"